<template>
  <div :style="styles.base">
    <div :class="getCss('claim-button')" @click="openDialog">
      <c-button :style="buttonImgStyle" :class="getCss('claim-button-title')"></c-button>
    </div>
    <c-base-dialog v-model="isShow" :option="iosPaymentGuideOption" @close="isShow = false" v-transfer-dom>
      <template slot="body" v-if="dialogStatus === 1">
        <div :class="getCss('dialog-body')">
          <div :class="getCss('dialog-title')">你已安装心悦专属包</div>
          <div>现在注册游戏，即可完成激活</div>
          <div @click="installApp">
            <c-button
              ref="button"
              :class="getCss('dialog-button-rawards')"
              v-text="content"
              v-bind="$props"
              style="position: static !important; display: inline-block !important"
            ></c-button>
          </div>
        </div>
      </template>
      <template slot="body" v-if="dialogStatus === 2">
        <div :class="getCss('dialog-body')">
          <div>你未安装心悦专属包，无法领奖</div>
          <div>重新安装，恢复你的奖励</div>
          <div @click="installApp">
            <c-button
              ref="button"
              :class="getCss('dialog-button-rawards')"
              v-text="content"
              v-bind="$props"
              style="position: static !important; display: inline-block !important"
            ></c-button>
          </div>
        </div>
      </template>
      <template slot="body" v-if="dialogStatus === 3">
        <div :class="getCss('dialog-body')">
          <div>你未安装心悦专属包，无法领奖</div>
          <div>立即安装，恢复你的奖励</div>
          <div @click="installApp">
            <c-button
              ref="button"
              :class="getCss('dialog-button-rawards')"
              v-text="content"
              v-bind="$props"
              style="position: static !important; display: inline-block !important"
            ></c-button>
          </div>
        </div>
      </template>
      <template slot="body" v-if="dialogStatus === 4">
        <div>
          <div :class="getCss('dialog-title')">领奖激活成功</div>
        </div>
      </template>
      <template slot="body" v-if="dialogStatus === 5">
        <div :class="getCss('dialog-body')">
          <div :class="getCss('dialog-title')">领奖激活失败</div>
          <div>你未通过心悦专属包注册，无法领奖</div>
          <div>下次通过心悦下载注册，不再错过奖励</div>
          <div>
            <button style="width: 3rem" :class="getCss('dialog-button-rawards-sure')" @click="closeDialog">我知道了</button>
          </div>
        </div>
      </template>
      <template slot="body" v-if="dialogStatus === 6">
        <div :class="getCss('dialog-body')">
          <div :class="getCss('dialog-title')">可激活</div>
          <div>从本页面下载游戏登录，将完成激活</div>
          <div @click="installApp">
            <c-button
              ref="button"
              :class="getCss('dialog-button-rawards')"
              v-text="content"
              v-bind="$props"
              style="position: static !important; display: inline-block !important"
            ></c-button>
          </div>
        </div>
      </template>
      <template slot="body" v-if="dialogStatus === 7">
        <div :class="getCss('dialog-body')">
          <div :class="getCss('dialog-title')">可激活</div>
          <div>从本页面立即登录游戏，将完成激活</div>
          <div @click="installApp">
            <c-button
              ref="button"
              :class="getCss('dialog-button-rawards')"
              v-text="content"
              v-bind="$props"
              style="position: static !important; display: inline-block !important"
            ></c-button>
          </div>
        </div>
      </template>
      <template slot="body" v-if="dialogStatus === 8">
        <div :class="getCss('dialog-body')">
          <div>你已登录过游戏</div>
          <div>仅在登录前可检测激活状态</div>
          <div>
            <button style="width: 3rem" :class="getCss('dialog-button-rawards-sure')" @click="closeDialog">我知道了</button>
          </div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import button from '@tencent/ceiba-act-public-button';

export default {
  name: 'CTgclubActivateRewards',
  mixins: [componentBaseMixin],
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  data() {
    return {
      cssPrefix: 'tgclub-activate-rewards-',
      isShow: false,
      dialogStatus: 1,
      content: '立即登录',
    };
  },
  computed: {
    buttonImgStyle() {
      return {
        background: `url(${this.configurationData.buttonImg}) no-repeat center top` || '',
        backgroundSize: '100% 100%',
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    iosPaymentGuideOption() {
      // let bagImg = 'https://act.xinyue.qq.com/act/https://act.xinyue.qq.com/act/https://act.xinyue.qq.com/act//bgcimg.png';
      let bagImg = this.configurationData.dialogConfig.dialogStyle.backgroundImage || '';
      return Object.assign({}, this.dialogConfig, {
        dialogStyle: {
          backgroundImage: bagImg || '',
          color: this.configurationData.dialogColor || '',
        },
        width: '7rem',
        header: false,
        body: false,
        fotter: false,
      });
    },
  },
  async mounted() {
    console.log('activate-rewards 1.1.20 configurationData', this.configurationData);
    await this.initialize();
  },
  methods: {
    // 如果有安装包就安装 如果没有就下载
    async installApp() {
      const gameInfo = await this.$axiosInstance.get(
        `https://wang.xinyue.qq.com/api/fly/getPkgByGid?gid=${this.configurationData.gameID}`
      );
      const response = await window.UPBridge?.checkDownloadState({ url: gameInfo.info.androidDownloadUrl });
      console.log(response, '检测下载状态');
      // 当前已经是下载状态 不需要在调用下载

      if (response.data.state === 2) {
        this.isShow = false;
        return;
      }
      const { targetComponentId = '', targetComponentActionName = '' } = this.configurationData;
      console.log(targetComponentId, 'targetComponentId', 'targetComponentActionName', targetComponentActionName);

      const parentRef = (node) => {
        if (!node?.$parent) {
          return {};
        }
        // eslint-disable-next-line  no-underscore-dangle
        if (
          node.$parent &&
          (node.$parent?.$el?._prevClass === 'page-scroll' ||
            // eslint-disable-next-line no-underscore-dangle
            node.$parent?.$el?._prevClass === 'page-content')
        ) {
          return node.$parent;
        }

        return parentRef(node.$parent);
      };
      const parentNode = parentRef(this.$refs.button);

      console.log(parentNode, 'parentNode111111');
      if (!parentNode || !parentNode.$refs) {
        console.error('--parentNode-- not found ', parentNode);
      }

      const component = parentNode?.$refs[targetComponentId]?.[0];
      console.log(component);
      if (component && targetComponentActionName) {
        component[targetComponentActionName]();
        console.warn('-- call target component and call method params is =', component, targetComponentActionName);
      }

      this.isShow = false;
      // const gameInfo = await getGameInfoData(this.configurationData.gameID);
      // const callGameParams = { isNeedDownload: true, targetGameInfo: gameInfo };
      // await callAndDownLoadGame(callGameParams);
    },

    async initialize() {
      this.$onLogined(() => {
        console.log('登录完成');
      });
    },
    // 关闭弹框
    closeDialog() {
      this.isShow = false;
    },
    // 打开弹框判断是否安卓还是ios
    async openDialog() {
      const xinyueisDyeFlow = await this.flowRequest({
        flowId: this.configurationData.xinyueIsDye,
      });

      console.log('是否心悦染色查看', xinyueisDyeFlow);
      console.log('ceibaComponentId', this.cid);
      this.reportClick({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });
      console.log('判断是否ios设备', this.$platform.isIos);
      if (this.$platform.isIos) {
        console.log('是ios');
        this.iosFlow();
      } else {
        console.log('是安卓');
        this.androidFlow();
      }
    },
    // 安卓流程
    async androidFlow() {
      const andInstall = await window.UPBridge?.isAppInstalled({
        pkgName: this.configurationData.pkgName,
      });
      console.log('是否安装app', andInstall);

      const isRole = await this.flowRequest({
        flowId: this.configurationData.iosRole,
      });
      console.log('是否有角色', isRole);

      const xinyueisDyeFlow = await this.flowRequest({
        flowId: this.configurationData.xinyueIsDye,
      });

      console.log('是否心悦染色查看', xinyueisDyeFlow);

      const channelRes = await window.UPBridge?.getAppInstalledChannel({
        pkgName: this.configurationData.pkgName, // 指定App的包名
        channelTag: 'channelId', // 渠道字段名，默认传 'channelId'
      });
      console.log('染色渠道查看', channelRes);

      if (!xinyueisDyeFlow.data.channelId) {
        if (andInstall.data.isInstall) {
          if (!channelRes.data.channelInfo) {
            console.log('没渠道号不对 重新一键安装');
            this.isShow = true;
            this.dialogStatus = 2;
            this.content = '一键重装';
          } else {
            console.log('没有染色但是已经安装');
            if (
              channelRes.data.channelInfo === '10058447' ||
              channelRes.data.channelInfo === '10058446' ||
              channelRes.data.channelInfo === '10058445' ||
              channelRes.data.channelInfo === '10030476'
            ) {
              console.log('已经安装心悦包');
              this.isShow = true;
              this.dialogStatus = 1;
              this.content = '启动游戏';
            } else {
              console.log('没有染色但是已经安装非心悦包');
              this.isShow = true;
              this.dialogStatus = 2;
              this.content = '一键重装';
            }
          }
        } else {
          console.log('没有下载');
          this.isShow = true;
          this.dialogStatus = 3;
          this.content = '立即下载';
        }
      } else {
        if (
          xinyueisDyeFlow.data.channelId === '10058447' ||
          xinyueisDyeFlow.data.channelId === '10058446' ||
          xinyueisDyeFlow.data.channelId === '10058445' ||
          xinyueisDyeFlow.data.channelId === '10030476'
        ) {
          console.log('已经染色');
          this.isShow = true;
          this.dialogStatus = 4;
        } else {
          console.log('不是心悦染色');
          this.isShow = true;
          this.dialogStatus = 5;
        }
      }
    },
    // ios流程
    async iosFlow() {
      const iosInstall = await window.UPBridge?.isAppInstalled({
        iosScheme: this.configurationData.iosScheme,
      });

      const xinyueisDyeFlow = await this.flowRequest({
        flowId: this.configurationData.xinyueIsDye,
      });
      console.log('是否心悦染色查看', xinyueisDyeFlow);

      const isRole = await this.flowRequest({
        flowId: this.configurationData.iosRole,
      });
      console.log('是否有角色', isRole);

      if (iosInstall.data.isInstall) {
        if (isRole.data.ret === 0) {
          console.log('有角色 已经安装游戏');
          this.isShow = true;
          this.dialogStatus = 8;
        } else {
          console.log('没有角色 已经安装游戏');
          this.isShow = true;
          this.dialogStatus = 7;
          this.content = '启动游戏';
        }

        console.log('ios已安装');
      } else {
        this.isShow = true;
        this.dialogStatus = 6;
        console.log('ios未安装');
        this.content = '立即安装';
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
